
import { Button, TextField } from '@mui/material';
import Page from './Page.js';
import withRouterParams from '../withRouterParams.js';
import { errorToast } from '../toast.js';
import { hideLoading, showLoading } from '../loading.js';
import request from '../request.js';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';


const STAGE = {
   PASSWORD: 'password',
   SUCCESS: 'success',
   FAILURE: 'failure'
}

class _SetPassword extends Page {

   state = {
      stage: STAGE.PASSWORD,
      errorMessage: ''
   }

   submit = async () => {

      // extract
      const txtPassword = document.getElementById('txt-password');
      const txtConfirm = document.getElementById('txt-confirm');
      const password = txtPassword.value;
      const confirm = txtConfirm.value;

      // validate
      if (!password) {
         errorToast('Password is required');
         return txtPassword.focus();
      }

      if (!confirm) {
         errorToast('Password confirmation is required');
         return txtConfirm.focus();
      }

      if (password !== confirm) {
         errorToast('Passwords do not match');
         txtPassword.value = '';
         txtConfirm.value = '';
         return txtPassword.focus();
      }

      // submit
      try {

         showLoading();

         const { ref_code } = this.props.params;
         await request.post('/api/auth/password', { password, ref_code });

         this.setState({ stage: STAGE.SUCCESS });

      } catch (err) {
         this.setState({ errorMessage: err.message, stage: STAGE.FAILURE });
      } finally {
         hideLoading();
      }

   }

   _render() {

      const { stage, errorMessage } = this.state;
      let content;

      switch (stage) {

         case STAGE.PASSWORD:
            content = <div className='[&>*]:mt-4 mb-2'>
               <TextField
                  id='txt-password'
                  label='Password'
                  type='password'
                  variant='outlined'
                  fullWidth
                  size='small'
               />
               <TextField
                  id='txt-confirm'
                  label='Confirm password'
                  type='password'
                  variant='outlined'
                  fullWidth
                  size='small'
               />

               <Button
                  variant='contained'
                  onClick={this.submit}
                  fullWidth
               >
                  SAVE
               </Button>
            </div>

            break;

         case STAGE.SUCCESS:
            content = <div className='bg-green-50 text-green-700 p-4'>
               Your password has been set. You can go to login now.
            </div>
            break;

         default:
            content = <div className='bg-red-50 text-red-500 p-4'>
               {errorMessage}
            </div>
            break;

      }

      return <div className='page-height flex items-center justify-center'>
         <div className='w-full md:w-[400px] p-4 bg-white border-y-[4px] border-x-[1px] rounded px-8 py-4'>
            <div className='text-3xl font-bold text-gray-600 my-2'>
               Set your password
            </div>
            {content}

            <div className='border-t-[1px] mt-4 pt-2 text-right'>
               <Button
                  variant='text'
                  onClick={() => window.App.redirect('/login')}
                  endIcon={<ArrowForwardIcon />}
                  size='large'
               >
                  GO TO LOGIN
               </Button>
            </div>
         </div>
      </div>
   }
}

const SetPassword = withRouterParams(_SetPassword);
export default SetPassword;